import type { SurfacePoint } from '@repo/api-contracts';
import type { ReactElement } from 'react';
import type { PhotoDimensions } from '@/entities/edit-area';

interface OutlinePathOverlayProps {
  /** 찍은 점(사진 px). 좌표 변환은 호출자가 한다. */
  readonly pointsPx: readonly SurfacePoint[];
  readonly photoSize: PhotoDimensions;
  /** 첫 점을 눌러 닫을 수 있을 만큼 점이 모였는가. 그러면 첫 점을 크게 칠한다. */
  readonly canClose: boolean;
}

/** 작성 중인 열린 경로. 점선과 점만 그리며 포인터 이벤트는 받지 않는다(클릭은 캔버스가 받는다). */
export const OutlinePathOverlay = ({
  pointsPx,
  photoSize,
  canClose,
}: OutlinePathOverlayProps): ReactElement | null => {
  if (pointsPx.length === 0) return null;
  const radius = Math.max(photoSize.widthPx, photoSize.heightPx) * 0.005;

  return (
    <g pointerEvents="none">
      <polyline
        points={pointsPx.map((point) => `${point.x},${point.y}`).join(' ')}
        fill="none"
        stroke="#2563eb"
        strokeWidth={2}
        strokeDasharray="6 4"
        vectorEffect="non-scaling-stroke"
      />
      {pointsPx.map((point, index) => (
        <circle
          // biome-ignore lint/suspicious/noArrayIndexKey: 점은 찍은 순서가 곧 식별자이고 중간 삽입이 없다.
          key={index}
          cx={point.x}
          cy={point.y}
          r={index === 0 && canClose ? radius * 1.8 : radius}
          fill={index === 0 && canClose ? '#2563eb' : 'white'}
          stroke="#2563eb"
          strokeWidth={2}
          vectorEffect="non-scaling-stroke"
          data-testid={`outline-draft-point-${index}`}
        />
      ))}
    </g>
  );
};
